export default __webpack_public_path__ + "static/media/partner_3.fb80c29c.png";